import React, { Component } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import {
  getAllPacks,
  updatePackStatus,
  deletePack,
  getPackDetail,
} from '../app/store/actions/packs';
import ModalComponent from '../components/modal';
import PackDetailModal from '../components/modal/PackDetailModal';
import TableFilters from '../components/table/TableFilters';

class PacksPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 10,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listPacks: [],
      totalRecord: 0,
      showPackDetail: false,
      packDetail: null,
      pendingDeleteId: null,
      filters: {
        status: '',
        pricingMethod: '',
        dateEffective: '',
        dateExpiration: '',
      },
    };

    this.tableHeader = [
      { key: 'name', value: I18n.t('name') },
      { key: 'dateEffective', value: I18n.t('dateEffective') },
      { key: 'dateExpiration', value: I18n.t('dateExpiration') },
      { key: 'sales', value: I18n.t('sales') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getAllPacks();
  }

  openPackDetail = async (packId) => {
    try {
      const detail = await this.props.getPackDetail(packId);
      this.setState({ showPackDetail: true, packDetail: detail });
    } catch (err) {
      this.setState({
        showModal: true,
        showCancel: false,
        titleModal: I18n.t('Error'),
        titleModalBody: I18n.t('errorOcurred'),
      });
    }
  };

  openEditForm = async (packId) => {
    try {
      const detail = await this.props.getPackDetail(packId);
      history.push({
        pathname: ROUTES.FORM,
        screenComming: 'packs',
        selectedPack: detail,
      });
    } catch (err) {
      this.setState({
        showModal: true,
        showCancel: false,
        titleModal: I18n.t('Error'),
        titleModalBody: I18n.t('errorOcurred'),
      });
    }
  };

  updatePacksStatus = async ({ id, status } = {}) => {
    try {
      await this.props.updatePackStatus(id, status);

      await this.getAllPacks();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = error.code && error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred'),
        });
      }
    }
  };

  adjustData = async (count = 0, rows = []) => {
    const listPacks = rows.map((element, index) => {
      const isExpired = moment(element.dateExpiration).isBefore(
        moment(),
        'day',
      );

      return {
        key: index,
        id: element.id,
        name: element.name,
        dateEffective: moment(element.dateEffective).format('DD/MM/YYYY'),
        dateExpiration: moment(element.dateExpiration).format('DD/MM/YYYY'),
        sales: element.sales || 0,
        status: (
          <div className="row margin-left-0">
            <button
              type="button"
              className={`btn btn-${
                element.status ? 'warning' : 'dark'
              } promotion-btn-${element.status ? 'warning' : 'active'}`}
              disabled={!element.status && isExpired}
              title={!element.status && isExpired ? I18n.t('packExpired') : ''}
              onClick={() => this.updatePacksStatus({
                id: element.id,
                status: !element.status,
              })
              }
            >
              {element.status ? I18n.t('disable') : I18n.t('active')}
            </button>
          </div>
        ),
        action: (
          <div
            className="btn-group"
            role="group"
            aria-label="Button group with nested dropdown"
          >
            <div className="btn-group" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                className="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {I18n.t('action')}
              </button>
              <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.openPackDetail(element.id)}
                >
                  {I18n.t('visualize')}
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.openEditForm(element.id)}
                >
                  {I18n.t('edit')}
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.askDeletePack(element.id)}
                >
                  {I18n.t('delete')}
                </button>
              </div>
            </div>
          </div>
        ),
      };
    });

    this.setState({
      totalRecord: count,
      listPacks,
    });
  };

  setFilter = (key, value) => {
    this.setState(
      prevState => ({
        filters: { ...prevState.filters, [key]: value },
        page: 1,
      }),
      this.getAllPacks,
    );
  };

  clearFilters = () => {
    this.setState(
      {
        filters: {
          status: '',
          pricingMethod: '',
          dateEffective: '',
          dateExpiration: '',
        },
        page: 1,
      },
      this.getAllPacks,
    );
  };

  getAllPacks = async () => {
    const {
      search,
      page,
      limit,
      orderBy = '',
      field = '',
      filters,
    } = this.state;
    const skip = (page - 1) * limit;
    const {
      status, pricingMethod, dateEffective, dateExpiration,
    } = filters || {};

    try {
      const data = await this.props.getAllPacks(
        limit,
        skip,
        search,
        orderBy,
        field,
        status,
        pricingMethod,
        dateEffective,
        dateExpiration,
      );

      await this.adjustData(data.count, data.rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = error.code && error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  };

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getAllPacks();
  };

  setValue = async (field, value) => new Promise((resolve) => {
    this.setState({ [field]: value }, resolve);
  });

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getAllPacks();
  };

  handleFilterChange = (key, value) => {
    if (key === 'limit') {
      this.setState({ limit: value, page: 1 }, this.getAllPacks);
    } else {
      this.setFilter(key, value);
    }
  };

  askDeletePack = (id) => {
    this.setState({
      showModal: true,
      showCancel: true,
      titleModal: I18n.t('Error'),
      titleModalBody: I18n.t('deletePack'),
      pendingDeleteId: id,
    });
  };

  confirmModal = async () => {
    const { pendingDeleteId } = this.state;

    if (!pendingDeleteId) {
      this.setState({ showModal: false });
      return;
    }

    try {
      await this.props.deletePack(pendingDeleteId);
      this.setState({ showModal: false, pendingDeleteId: null });
      await this.getAllPacks();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      const messageError = (error && error.message) || I18n.t('errorOcurred');

      this.setState({
        showModal: true,
        showCancel: false,
        titleModal: I18n.t('Error'),
        titleModalBody: messageError,
        pendingDeleteId: null,
      });
    }
  };

  render() {
    const {
      limit,
      page,
      listPacks,
      totalRecord,
      titleModal,
      titleModalBody,
      showModal,
      showCancel,
      showPackDetail,
      packDetail,
      filters,
    } = this.state;

    const hasActiveFilters = filters.status !== ''
      || filters.pricingMethod !== ''
      || filters.dateEffective !== ''
      || filters.dateExpiration !== '';

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton
          route={{ pathname: ROUTES.FORM, screenComming: 'packs' }}
        />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_PACKS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="importPacks" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <PackDetailModal
          visible={showPackDetail}
          pack={packDetail}
          closeModal={() => this.setState({ showPackDetail: false, packDetail: null })
          }
        />
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false, pendingDeleteId: null })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '400px', height: '250px' }}
          showButtons
          confirmModal={this.confirmModal}
        />
        <TableFilters
          values={{ ...filters, limit }}
          onChange={this.handleFilterChange}
          hasActiveFilters={hasActiveFilters}
          onClear={this.clearFilters}
          fields={[
            {
              type: 'select',
              key: 'status',
              label: I18n.t('status'),
              minWidth: '130px',
              placeholder: I18n.t('visualizeAllStatus'),
              options: [
                { label: I18n.t('active'), value: 'true' },
                { label: I18n.t('inactive'), value: 'false' },
              ],
            },
            {
              type: 'select',
              key: 'pricingMethod',
              label: I18n.t('pricingMethodShort'),
              minWidth: '150px',
              options: [
                { label: I18n.t('fixed'), value: 'fixed' },
                { label: I18n.t('percentage'), value: 'percentage' },
              ],
            },
            {
              type: 'date',
              key: 'dateEffective',
              label: I18n.t('dateEffective'),
            },
            {
              type: 'date',
              key: 'dateExpiration',
              label: I18n.t('dateExpiration'),
            },
            {
              type: 'perPage',
              key: 'limit',
              label: I18n.t('itemsPerPage'),
            },
          ]}
        />

        <Table
          title={I18n.t('Packs')}
          buttons={tableButtons}
          header={this.tableHeader}
          lines={listPacks}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllPacks: (
    limit,
    skip,
    search,
    orderBy,
    field,
    status,
    pricingMethod,
    dateEffective,
    dateExpiration,
  ) => dispatch(
    getAllPacks(
      limit,
      skip,
      search,
      orderBy,
      field,
      status,
      pricingMethod,
      dateEffective,
      dateExpiration,
    ),
  ),
  updatePackStatus: (id, status) => dispatch(updatePackStatus(id, status)),
  deletePack: id => dispatch(deletePack(id)),
  getPackDetail: id => dispatch(getPackDetail(id)),
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PacksPage);
